module.exports = __webpack_public_path__ + "img/grade1.3344ba74.png";